module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.organizations.black-9d67ac06a7c9cf4e25fd72b67b35a27f.svg";